import { Loader2 } from "lucide-react";

export default function LoadingOverlay() {
  return (
    <div className="LoadingOverlay">
      <Loader2 className="h-8 w-8 animate-spin" />
    </div>
  );
}
